import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const AbsoluteLink = ({ children, to }) => {
  const { locale } = useIntl();
  // The tenants' websites do not include the language code in the URL for English.
  // If the domain name is followed by the "/en" path, a 404 error is thrown.
  const localePath = locale === 'en' ? '' : `/${locale}`;
  const url = useSelector(state => state.tenant.url);
  const link = `${url}${localePath}/${to}`;
  return (<a href={link}>{children}</a>);
};

AbsoluteLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
};

AbsoluteLink.defaultProps = {
  to: '',
};

export default AbsoluteLink;
